<template>
  <div>
    <div
      style="padding: 0 18px;display: flex;justify-content: space-between;align-items: center;height: 60px;width: 100%;position: fixed;top: 0;left: 0;box-sizing: border-box;background: #fff;border-bottom: 1px solid #CFD6EA;z-index: 99;">
      <img src="../../assets/mobile/logo2.png" style="width: 122px;height: 34px;" @click="goHome">
    </div>
    <div style="height: 60px;"></div>
    <div style="padding: 12px;">
      <div style="font-size: 24px;font-family: PingFangSC-Medium, PingFang SC;color: #36444D;line-height: 45px;">{{content.title}}</div>
      <div style="display: flex;align-items: center;margin: 15px 0"><img src="../../assets/images/time.png" style="width: 16px;height: 16px;margin-right: 5px" alt=""><span style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #767D8A;line-height: 22px;">{{content.publishTime}}</span></div>
      <div v-html="content.content"></div>

    </div>
  </div>
</template>
<script>
  import {
    getHotArticles,
    getIndex,
    getArticle,
    getLinks,
    getInfo,
    getMedia,
    articleById
  } from '@/api/api'
  import {
    serverUrl
  } from '@/utils/server'
  export default {
    data() {
      return {
        id: '',
        content: {}
      }
    },
    methods: {
      
        goHome() {
          this.$router.push({
            path: '/mobile',
          })
        },
      setArticleById() {
        articleById({id: this.id}).then(res => {
            this.content = res
        })
      },
    },
    mounted() {
        this.id = this.$route.query.id
        this.baseURL = serverUrl.baseURL
        this.setArticleById()
    }
  }
</script>
<style scoped>
  .banner {
    width: 100%;
    height: 500px;
    background: url(../../assets/mobile/banner@2x.png) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }

  .ListBanner {
    height: 150px;width: 100%;
    background: url(../../assets/mobile/bj_5@2x.png) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/MobileNewsDetails.vue